var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.nearQuestions),function(char){return _c('span',{key:char,staticClass:"near-question",class:_vm.questionClass(char)},[_vm._v(" "+_vm._s(char)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }